import images from "./images";

const About = {
  sub: "About Us",
  heading: "Your Trusted Source for Quality Woodwork",
  description: [
    "Welcome to TimberCraft, your premier destination for high-quality woodwork solutions. We are dedicated to providing exceptional craftsmanship and services to enhance the beauty, functionality, and durability of your space. Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptatem enim nobis ea quo sint vero laboriosam ex repellendus.",
  ],
  experience: {
    year: "25",
    text: "years of experience",
  },
  points: [
    "Custom Woodwork Creations",
    "Professional Carpentry Services",
    "Natural Wood Selections",
    "Precision Craftsmanship",
    "Expert Consultation & Support",
  ],
  image: {
    src1: images.about1,
    src2: images.about2,
    src3: images.about3,
    alt1: "About-Image1",
    alt2: "About-Image2",
    alt3: "About-Image3",
  },
  button: {
    text: "Get Started",
    link: "Pricing",
  },
};

export default About;